<template>
	<div class="booking__room">
		<template v-if="!mobile">
			<modal :name="modalName" :width="800" :height="450">
				<div class="carousel">
					<div class="carousel__primary">
						<div class="carousel__media">
							<div class="carousel__image" :style="{ backgroundImage: `url(${image})`}" @click="show"></div>
						</div>
						<div class="carousel__arrows-container">

							<template v-if="!hidePrev">
								<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="carousel__arrows carousel__arrows--prev" @click="directional('prev')">
									<circle cx="20" cy="20" r="19.5" fill="white" stroke="#DADDDF"/>
									<path d="M17 14L23 20L17 26" stroke="#C45F24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</template>

							<template v-if="!hideNext">
								<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="carousel__arrows carousel__arrows--next" @click="directional('next')">
									<circle cx="20" cy="20" r="19.5" fill="white" stroke="#DADDDF"/>
									<path d="M17 14L23 20L17 26" stroke="#C45F24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</template>
						</div>
					</div>
				</div>
			</modal>
		</template>

		<h1 class="booking__title" v-html="roomName"></h1>

		<div class="booking__image-container" @click="show">
			<div class="booking__image" :style="{ backgroundImage: `url(${poster})`}"></div>
			<div class="booking__see-more">See more photos!</div>
		</div>

		<div class="booking__carousel-mobile">
			<div class="carousel">
				<div class="carousel__primary">
					<div class="carousel__media">
						<div class="carousel__image" :style="{ backgroundImage: `url(${image})`}"></div>
					</div>
					<div class="carousel__arrows-container">

						<template v-if="!hidePrev">
							<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="carousel__arrows carousel__arrows--prev" @click="directional('prev')">
								<circle cx="20" cy="20" r="19.5" fill="white" stroke="#DADDDF"/>
								<path d="M17 14L23 20L17 26" stroke="#C45F24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</template>

						<template v-if="!hideNext">
							<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="carousel__arrows carousel__arrows--next" @click="directional('next')">
								<circle cx="20" cy="20" r="19.5" fill="white" stroke="#DADDDF"/>
								<path d="M17 14L23 20L17 26" stroke="#C45F24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</template>
					</div>
				</div>
			</div>
		</div>

		<p class="booking__info" v-html="roomDesc"></p>
	</div>
</template>

<script type="text/javascript">
    export default {

        data() {
            return {
	            hideNext: false,
                hidePrev: true,
                image: '',
                images: [],
                index: 0,
	            poster: '',
	            modalName: '',
                mobile: window.innerWidth <= 768
            }
        },

        props: {
            items: Array,
	        roomName: String,
	        roomDesc: String
        },

        created() {
            addEventListener('resize', () => {
                this.mobile = innerWidth <= 768;
            });
        },

	    mounted() {
            this.images = JSON.parse(this.items);
            this.modalName = `modal-${this.images[0].image.id}`;
            this.images = this.images.map((el, i) => {
                return {
                    index: i,
                    image: el.image.sizes.large
                }
            });

            this.image = this.images[0].image;
            this.poster = this.image;
            console.log(this.modalName);
	    },

	    methods: {
            show() {
                console.log(this.mobile);
                if(!this.mobile) {
                    this.$modal.show(this.modalName);
                }
            },
            hide() {
                if(!this.mobile) {
                    this.$modal.hide(this.modalName);
                }
            },
            directional(direction) {
                const length = this.images.length - 1;

                if (this.index <= length && direction === 'next') {
                    this.image = this.images[this.index + 1].image;
                    this.hidePrev = false;

                    if(this.index === length - 1) {
                        this.hideNext = true;
                    }

                    this.index += 1;
                } else if(this.index > 0 && direction === 'prev') {
                    this.image = this.images[this.index - 1].image;
                    this.hideNext = false;

                    if(this.index === 1) {
                        this.hidePrev = true;
                    }

                    this.index -= 1;
                }
            }
	    }

    }
</script>


// WEBPACK FOOTER //
// Room.vue?3cab47e0